import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SamplePageComponent } from './components/sample-page/sample-page.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { LogHandlerService } from './services/log-handler.service';
import { DummyTeacherComponent } from './components/dummy-teacher/dummy-teacher.component';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastContainerComponent } from './internal-components/toast-container/toast-container.component';
import { SpinnerComponent } from './internal-components/spinner/spinner.component';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { HomePageComponent } from './components/home/home.component';
import { TopNavComponent } from './internal-components/top-nav/top-nav.component';
import { BlogDetailsComponent } from './components/blog-details/blog-details.component';
import { ServiceDetailsComponent } from './components/service-details/service-details.component';
import { PortfolioComponent } from './components/portfolio/portfolio.component';
import { PortfolioDetailsComponent } from './components/portfolio-details/portfolio-details.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { ContactSalesComponent } from './components/contact-sales/contact-sales.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';



@NgModule({
  declarations: [
    AppComponent,
    SamplePageComponent,
    NotFoundComponent,
    DummyTeacherComponent,
    ToastContainerComponent,
    SpinnerComponent,
    AboutUsComponent,
    TopNavComponent,
    HomePageComponent,
    BlogDetailsComponent,
    ServiceDetailsComponent,
    PortfolioComponent,
    PortfolioDetailsComponent,
    ContactUsComponent,
    ContactSalesComponent,
    SignUpComponent,
  ],
  imports: [
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    NgbToastModule
  ],
  providers: [
    { provide: ErrorHandler, useClass: LogHandlerService },
    NgbActiveModal
  ],
  bootstrap: [AppComponent],
  exports: []
})
export class AppModule { }
